const a = "af.search-param-changed", s = class s extends CustomEvent {
  constructor(t) {
    super(a, { detail: { searchParam: t }, bubbles: !0, composed: !0 });
  }
};
s.EVENT_NAME = a;
let e = s;
export {
  a as EVENT_NAME,
  e as default
};
//# sourceMappingURL=SearchParamChangedEvent.js.map
